import { render, staticRenderFns } from "./InMailDetail.vue?vue&type=template&id=79d0327a&"
import script from "./InMailDetail.vue?vue&type=script&lang=js&"
export * from "./InMailDetail.vue?vue&type=script&lang=js&"
import style0 from "./InMailDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports